import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
  APP_INITIALIZER,
} from '@angular/core';
import { switchMap, catchError, of } from 'rxjs';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { routes } from './app.routes';

import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { credentialsInterceptor } from './core/interceptors/credentials.interceptor';
import { httpToastInterceptor } from './core/interceptors/toast.interceptor';
import { globalHttpErrorInterceptor } from './core/handlers/global-error-handlers';
import { CsrfService } from './core/services/csrf.service';
import { AuthService } from './core/services/auth.service';
import { CoreService } from './core/services/core.service';
import { MessageService } from 'primeng/api';

export const appConfig: ApplicationConfig = {
  providers: [
    MessageService,
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(
      withInterceptors([credentialsInterceptor, globalHttpErrorInterceptor, httpToastInterceptor]),
    ),
    {
      provide: APP_INITIALIZER,
      useFactory: (csrfService: CsrfService, authService: AuthService, coreService: CoreService) => () =>
        coreService.fetchAppConfig().pipe(
          switchMap(() => csrfService.ensure()),
          switchMap(() => authService.fetchProfile()),
          catchError(() => of(null))
        ),
      deps: [CsrfService, AuthService, CoreService],
      multi: true,
    },
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: '.dark',
        },
      },
    }),
  ],
};
